import type { FCC } from 'react-fc';
import styled from 'styled-components';

/**
 * Wrap children in a container that takes full width and height according to the specified ratio.
 */
export const RatioBox: FCC<{ ratio: number }> = ({ children, className, ratio }) => (
    <Frame $ratio={ratio} className={className}>
        {children}
    </Frame>
);

const Frame = styled.div<{ $ratio: number }>`
    position: relative; /* so that elements inside are aligned to this ratio */
    aspect-ratio: ${({ $ratio }) => $ratio};
    place-content: center;
    > img,
    > picture,
    > picture > img,
    > svg,
    > video {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
